import apiClient from '../apiClient';

const profileService = {
  // Get user profile
  getProfile: async () => {
    try {
      
      const response = await apiClient.get('/ess/profile');
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Update user profile
  updateProfile: async (profileData) => {
    try {
      
      const response = await apiClient.put('/ess/profile', profileData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Change password
  changePassword: async (passwordData) => {
    try {
      
      const response = await apiClient.post('/auth/change-password', passwordData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Send OTP to current email for verification
  sendCurrentEmailOTP: async (purpose = 'email_change') => {
    try {
      
      const response = await apiClient.post('/auth/send-current-email-otp', { purpose });
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Verify current email OTP
  verifyCurrentEmailOTP: async (otpData) => {
    try {
      
      const response = await apiClient.post('/auth/verify-current-email-otp', otpData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Send OTP to new email
  sendNewEmailOTP: async (emailData) => {
    try {
      
      const response = await apiClient.post('/auth/send-new-email-otp', emailData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Verify new email OTP and update email
  verifyNewEmailOTP: async (otpData) => {
    try {
      
      const response = await apiClient.post('/auth/verify-new-email-otp', otpData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Change email
  changeEmail: async (emailData) => {
    try {
      
      const response = await apiClient.post('/auth/change-email', emailData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Verify email change OTP
  verifyEmailChangeOTP: async (otpData) => {
    try {
      
      const response = await apiClient.post('/auth/verify-email-change-otp', otpData);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Upload profile image
  uploadProfileImage: async (imageFile) => {
    try {
      
      const formData = new FormData();
      formData.append('profileImage', imageFile);
      
      const response = await apiClient.post('/ess/profile/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response;
    } catch (error) {
      
      throw error;
    }
  }
};

export default profileService;
